import client from "./client";

export function getConfirmation(year = null, month = null) {
  const params = year && month ? `?year=${year}&month=${month}` : "";
  return client.get(`/api/confirmation/${params}`).then((res) => res.data);
}

export function setConfirmation(body) {
  return client.post("/api/confirmation/", body).then((res) => res.data);
}
